import React from 'react';
import classNames from 'classnames';

class StyleButton extends React.Component {
  constructor() {
    super();
    this.onToggle = (e) => {
      e.preventDefault();
      this.props.onToggle(this.props.style);
    };
  }

  render() {
    let className = 'RichEditor-styleButton';
    if (this.props.active) {
      className += ' RichEditor-activeButton';
    }

    let btnClass = classNames(
      'RichEditor-styleButton'
      , 'yt-btn'
      , 'x-small'
      , { 'link': !this.props.active }

      , {
        'RichEditor-activeButton': this.props.active
        , 'primary': this.props.active
        , 'muted': !this.props.active
      }
    )

    return (
      <span className={btnClass} onMouseDown={ this.props.style === 'link' ? this.props.promptForLink : this.props.style === 'unlink' ? this.props.removeLink : this.onToggle}>
        {this.props.label}
      </span>
    );
  }
}

export default StyleButton;



// WEBPACK FOOTER //
// global/components/forms/editorComponents/StyleButton.js.jsx